import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import "./CustomItinerary.css";

import { MainLayout } from "../MainLayout";
import { ItineraryContent } from "./ItineraryContent";
import { B2BAgents4 } from "../B2BAgents/B2BAgents4/B2BAgents4";
import { Footer } from "../Footer";
import { useParams } from "react-router-dom";
import { getPackageById } from "../../API/home";
import { adminMediaUrl } from "../../config/api";
import SharePopUp from "../Home/sharepopup/sharepopup";

export const CustomItinerary = () => {
  // const { id } = useParams();
  const [data, setData] = useState(null);
  const { slug } = useParams();
  const id = slug.split("-").pop();
  const [showShare, setShowShare] = useState(false);

  // ✅ DEFINE SHARE URL (FIX)
  const shareUrl = `${window.location}`;

  useEffect(() => {
    if (showShare) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
  }, [showShare]);

  useEffect(() => {
    const fetchData = async () => {
      const res = await getPackageById(id);

      if (!res) return;

      const formatted = {
        title: res.packageName,
        banner: adminMediaUrl(res.profileImagePath),
        images: res.images?.map((img) =>
          img.url.startsWith("http") ? img.url : adminMediaUrl(img.url)
        ),

        itenary: res.itineraries?.map((it) => ({
          id: it.id,
          days: `Day ${it.day}`,
          destination: it.shortDescription,
          description: it.longDescription,
          images: it.images?.map((img) =>
            img.url.startsWith("http") ? img.url : adminMediaUrl(img.url)
          ),
        })),

        hotels: res.hotels,

        included: {
          title: "Inclusions",
          html: res.inclusionExclusion?.inclusionHtml || "",
        },

        excluded: {
          title: "Exclusions",
          html: res.inclusionExclusion?.exclusionHtml || "",
        },

        termCondition: {
          title: "Terms & Conditions",
          html: res.termsAndCondition || "",
        },

        confirmation: {
          title: "Confirmation Policy",
          html: res.confirmationPolicy || "",
        },

        refund: {
          title: "Refund Policy",
          html: res.refundPolicy || "",
        },

        cancellation: {
          title: "Cancellation Policy",
          html: res.cancellationPolicy || "",
        },
      };

      setData(formatted);
    };

    fetchData();
  }, [slug]);

  if (!data) return null;

  return (
    <>
      <MainLayout
        bgImage={
          data?.banner
            ? `url(${data.banner})`
            : `url("/assets/UAE-Banner.jpg")`
        }
        text1="DESTINATION"
        text2={data?.title}
        button={true}
      />

      <div className="standard-padding mobile-padding-top">

        {/* ================= HEADER ================= */}
        <div className="IndItinerary-header">
          <div>
            <h2 className="heading">{data.title}</h2>
          </div>

          <div>
            {/* ✅ ADD CLICK HANDLER (FIX) */}
            <img
              src="/assets/icons/IndiaIcon/ShareIcon.png"
              alt="share"
              className="IndItinerary-Share"
              onClick={() => setShowShare(true)}
              style={{ cursor: "pointer" }}
            />
          </div>
        </div>

        {/* ================= IMAGE GALLERY ================= */}
      <div className="IndItinerary-gallery">

  <div className="IndItinerary-gallery-left">
    <div className="packageDetailImageCard">
      <img src={data.images?.[0]} alt="" />
    </div>
  </div>

  <div className="IndItinerary-gallery-right">

    <div className="packageDetailImageCard">
      <img src={data.images?.[1]} alt="" />
    </div>

    <div className="packageDetailImageCard">
      <img src={data.images?.[2]} alt="" />
    </div>

  </div>

</div>

        {/* ================= MAIN CONTENT ================= */}
        <ItineraryContent data={data} />
      </div>

      <B2BAgents4 />
      <Footer />

      {/* ================= SHARE POPUP ================= */}
      {showShare && (
        <div
          className="hrs-share-backdrop2"
          onClick={() => setShowShare(false)}
        >
          <div onClick={(e) => e.stopPropagation()}>
            <SharePopUp
              title="Share"
              shareurl={shareUrl}   // ✅ FIXED
              showmail
              showwhatsapp
              showfacebook
              showLinkedin
              onClose={() => setShowShare(false)}
            />
          </div>
        </div>
      )}
    </>
  );
};